import React from 'react';
import { Button } from '@/components/common';

const DEFAULT_CLASS_NAME = 'font-semibold !h-[19px] shrink-0';

interface Props {
	leftButtonLabel: string;
	onLeftButtonClick: () => void;
	disabled?: boolean;
	/** Opt-in: replaces the default class only when provided. */
	className?: string;
}

export const PdfViewerControls: React.FC<Props> = ({
	leftButtonLabel,
	onLeftButtonClick,
	disabled,
	className,
}) => (
	<Button
		type="button"
		decoration="secondary"
		size="fit"
		disabled={disabled}
		className={className ?? DEFAULT_CLASS_NAME}
		onClick={onLeftButtonClick}
	>
		{leftButtonLabel}
	</Button>
);

interface DownloadControlProps {
	documentUrl: string;
	fileName?: string;
	disabled?: boolean;
	/** Opt-in: replaces the default class only when provided. */
	className?: string;
}

const handleDownload = (documentUrl: string) => {
	window.open(documentUrl, '_blank', 'noopener,noreferrer');
};

export const PdfViewerDownloadControl: React.FC<DownloadControlProps> = ({
	documentUrl,
	disabled,
	className,
}) => (
	<Button
		type="button"
		decoration="secondary"
		size="fit"
		disabled={disabled}
		className={className ?? DEFAULT_CLASS_NAME}
		onClick={() => handleDownload(documentUrl)}
	>
		Download
	</Button>
);
